import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-016e858e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-6 regist-h" }, "メールアドレスの登録")
], -1))
const _hoisted_2 = { class: "row justify-content-center mt-3" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "require" }, "メールアドレス", -1))
const _hoisted_5 = { class: "error-message" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 form-description" }, " スマートフォンで受信可能なメールアドレスを入力ください。 ")
], -1))
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-12 text-left check" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("に同意する")
const _hoisted_12 = { class: "error-message" }
const _hoisted_13 = { class: "row mt-1" }
const _hoisted_14 = { class: "col-12 text-left check" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode("に同意する")
const _hoisted_18 = { class: "error-message" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-primary"
    }, "次へ")
  ])
], -1))

import { Member, Shop } from '@/models';
import {ref, inject, toRefs, onMounted} from 'vue'
import { useRouter } from 'vue-router';
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { useCookies } from 'vue3-cookies';
import { DataStore } from 'aws-amplify';

interface Props {
  loading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    loading: { type: Boolean }
  },
  emits: ['startLoading', 'stopLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  loading: boolean;
}



const { loading } = toRefs(props);



const router = useRouter();
const {cookies} = useCookies();

const api: any = inject('api');

const shop = ref<Shop>();

const formSchema = yup.object({
  email: yup.string().required('必須項目です').matches(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-/+]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/i, '形式が間違っています'),
  privacy: yup.bool().required('必須項目です'),
  term: yup.bool().required('必須項目です')
})

const {errors, meta, handleSubmit} = useForm({ validationSchema: formSchema })

const { value: email } = useField<string>("email");
const { value: privacy } = useField<boolean>("privacy");
const { value: term } = useField<boolean>("term");

const submitHandler = handleSubmit(async() => {
   try {
    const code = await api.getRegistrationCode(email.value);
    await api.sendMail({
      email: email.value, 
      code: code.toString()
    });

    cookies.set('verify_email', email.value);

    router.push('./mailcode');

  }
  catch(e) {
    console.log(e);
  }
});

onMounted( async() => {
  try {
    const shopId: any = cookies.get('shopId');
    console.log(shopId);
    const buf = await DataStore.query(Shop, (s) => s.id('eq', shopId));
    shop.value = buf[0];
  }
  catch(e) {
    console.log(e);
  }
  emit('stopLoading');
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(submitHandler) && _unref(submitHandler)(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null))
          }, null, 512), [
            [_vModelText, _unref(email)]
          ]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(errors).email), 1)
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(privacy) ? (privacy).value = $event : null))
          }, null, 512), [
            [_vModelCheckbox, _unref(privacy)]
          ]),
          (shop.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createElementVNode("a", {
                  href: shop.value!.privacyPolicy!,
                  target: "_blank"
                }, "プライバシーポリシー", 8, _hoisted_10),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(errors).privacy), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(term) ? (term).value = $event : null))
          }, null, 512), [
            [_vModelCheckbox, _unref(term)]
          ]),
          (shop.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                _createElementVNode("a", {
                  href: shop.value!.termsOfService!,
                  target: "_blank"
                }, "利用規約", 8, _hoisted_16),
                _hoisted_17
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(errors).term), 1)
        ])
      ]),
      _hoisted_19
    ], 32)
  ], 64))
}
}

})